// material-ui
import { IconButton, Typography, Box, Divider } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import PrivateRoutList from '../../../../Router/PrivateRoutList';
import { FaUser,FaUsers } from "react-icons/fa";
import { GoHomeFill } from "react-icons/go";
import { useContext, useEffect, useState } from 'react';
import { BsBoxArrowLeft } from "react-icons/bs";
import { ContextUserInfo } from '../../../MainLayout/index';
import NavItem from './NavItem';
import logo from "../../../../assets/logo-login.png"
import UserApi from '../../../../api/UserApi';
import helper from '../../../../helper';
// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ({menues}) => {

  const { userInfo} = useContext(ContextUserInfo);
   

const[groupList,setGroupList]=useState(null);
useEffect(()=>{
UserApi.GetAllGroups().then((res) => {
     setGroupList(res.data.map((itm) => { return { groupId: itm.gId, title: itm.title ,icon:null} }));
});
},[]);
    
  const homemenu={
    id: 0,
    title: 'صفحه اصلی',
    type: 'item',
    url: 'Home',
    icon:GoHomeFill,
    breadcrumbs: false}
      const GenerateMenuList=(menus)=>{
         var filteredmnu=[];

        
        if(menus.length>0){
return groupList?.filter(g=>menus.some((m=>m.groupId===g.groupId))).map((mgrp)=>{
  filteredmnu=menus.filter(mnu=>mnu.groupId===mgrp.groupId);

  return {
  id: mgrp.groupId,
  title: mgrp.title,
  type: 'group',
  children:filteredmnu?.map((gmnu,index)=>{
    
    return {
      id: gmnu.menuId,
      title:gmnu.title,
      type: (gmnu.children)&&(gmnu.children.length>0)?'collapse':'item' ,
      url: helper.GetPath(gmnu.menuName,gmnu.params),
      icon: mgrp.icon,
      children:(gmnu.children)&&(gmnu.children.length>0)?gmnu.children.map((cmnu,index2)=>{
       return {
          id: cmnu.menuId,
          title: cmnu.title,
          type: 'item',
          url: helper.GetPath(cmnu.menuName,gmnu.params),
          breadcrumbs: false
      }
      })
      :[]
    }
  })

  
}})


        }
        
      }

    
    return <>
  <Box   >
                
                <NavItem key={homemenu.id} item={homemenu} level={1} />
                {
                  
      GenerateMenuList(menues)?.map((item) => {
                    return <NavGroup key={item.id} item={item} />;
        
        })

    }
    </Box>
    </>;
};

export default MenuList;
